module.exports = __webpack_public_path__ + "static/media/carts.15bed7cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/carts.png
// module id = 196
// module chunks = 0